import { Unity } from "./unity";
import { Driver } from "./driver";

export class Set {
    id:number = 0;
    truck_id:number = 0; 
    truck:Unity = null;
    trailer_1_id:number = 0;
    trailer_1:Unity = null;
    trailer_2_id:number = 0;
    trailer_2:Unity = null;
    trailer_3_id:number = 0;
    trailer_3:Unity = null;
    operator_id:number = 0;
    operator:Driver = null;
    helper_1_id:number = 0;
    helper_1:Driver = null;
    helper_2_id:number = 0;
    helper_2:Driver = null;
    contracted:boolean = true;
}
